import { FC, useContext } from 'react';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { isSFChatAvailable, isWhatsappAvailable } from '../../services/ChatService';
import ChatLink from '../ChatLink/ChatLink';
import WhatsAppLink from '../WhatsAppLink/WhatsAppLink';

export const ChatContainer: FC= () => {
  const { stylesheet } = useContext(StylesheetContext);

  return (
    <>
      {isWhatsappAvailable(stylesheet) && <WhatsAppLink />}
      {isSFChatAvailable() && <ChatLink />}
    </>
  );
};
